import { useKaiProApiState } from './useKaiProApiState';

/**
 * Detects current offline status and auto-updates on change.
 * Works in both React Web and React Native (via NetInfo).
 */
export const useIsOffline = (): boolean => useKaiProApiState().isOffline;
